export enum DiscountCodeStatus {
  applied = 'Applied',
  removed = 'Removed',
  failed = 'Failed',
}
